import axios from "axios";

/*** 
 * 取得 Google Sheet 資訊
 */
export async function googleSheetApiSupport(spread_id, sheet_id) {
  let api_url = `/api_v2/google_sheet/ajaxGetSheet/?spread_sheet_id=${spread_id}&sheet_id=${sheet_id}&disable_cache=1`;
  let response_result = [];
  await axios
    .get(api_url)
    .then((response) => {
      if (response.data.status == "success") {
        response_result = response.data.data.sheets_list;
      } else if (response.data.status == "failure") {
        console.log(response.data.error.message);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  return response_result;
}
